<div  class="option-box" #paymentWrapper *ngIf="!areAllPaymentOptionsDisabled()">
  <!-- PAYMENT OPTIONS -->
  <div class="option-wrapper" *ngIf="showPaymentOptions()">
    <div
      class="variant-wrapper checkbox label-as-h3 d-flex justify-content-between align-items-center p-3 pl-4 theme-light">
      <label for="payOnline" class="d-flex flex-column w-100 container mb-0 font-size-heading">
        <div class="d-flex section-title theme-light">
          {{'public.payment.payLaterSelection' | translate}}
        </div>
      </label>
    </div>
  </div>

  <div class="option-wrapper" *ngIf="showInactivePaymentOptions() && !isAdminOrderCapture()">
    <div
      class="variant-wrapper checkbox label-as-h3 d-flex justify-content-between align-items-center p-3 pl-4 theme-light">
      <label for="payOnline" class="d-flex flex-column w-100 container mb-0 font-size-heading">
        <div class="d-flex section-title theme-light">
          {{'public.payment.inactivePaymentTitle' | translate}}
        </div>
      </label>
    </div>
  </div>

  <!-- Options for Customer -->
  <div *ngIf="selectedStore.settings.PAYMENT_OPTION === 'optional' &&  !isAdminOrderCapture()">
    <div
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
      <label for="PAY_ONLINE" class="d-flex w-100 container pl-0 font-size-primary">
        <span>{{'public.payment.payOnline' | translate}}</span>
        <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment" value="PAY_ONLINE"
          (click)="togglePaymentPayLaterOption('PAY_ONLINE')" id="PAY_ONLINE" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="showPayLaterDefault()"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2"
      style="border: none;">
      <label for="PAY_LATER" class="d-flex w-100 container pl-0 font-size-primary">
        <span>{{"public.payment.payLater" | translate}}</span>
        <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment" value="PAY_LATER"
          (click)="togglePaymentPayLaterOption('PAY_LATER')" id="PAY_LATER" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="showPayLaterWithCard()"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2"
      [ngStyle]="{'border': selectedStore.settings.PAY_LATER_OPTION !== 'CASH_CARD' ? 'none' : undefined}">
      <label for="PAY_LATER_CARD" class="d-flex w-100 container pl-0 font-size-primary">
        <span>{{"public.payment.payLaterWithCard" | translate}}</span>
        <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment" value="PAY_LATER_CARD"
          (click)="togglePaymentPayLaterOption('PAY_LATER_CARD')" id="PAY_LATER_CARD" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="showPayLaterWithCash()"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2"
      style="border: none;">
      <label for="PAY_LATER_CASH" class="d-flex w-100 container pl-0 font-size-primary">
        <span>{{"public.payment.payLaterWithCash" | translate}}</span>
        <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment" value="PAY_LATER_CASH"
          (click)="togglePaymentPayLaterOption('PAY_LATER_CASH')" id="PAY_LATER_CASH" />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>

  <!-- Options for Customer -->
  <div *ngIf="selectedStore.settings.PAYMENT_OPTION === 'disabled' && selectedStore.settings.PAY_LATER_OPTION === 'CASH_CARD' &&  !isAdminOrderCapture()">

    <form [formGroup]="paymentSelectionForm">
      <div class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2"
        [ngStyle]="{'border': selectedStore.settings.PAY_LATER_OPTION !== 'CASH_CARD' ? 'none' : undefined}">
        <label for="PAY_CARD" class="d-flex w-100 container pl-0 font-size-primary">
          <span>{{"public.payment.payWithCard" | translate}}</span>
          <input
            type="radio"
            formControlName="selectedOptionalPayment"
            value="PAY_LATER_CARD"
            (click)="togglePaymentPayLaterOption('PAY_LATER_CARD')"
            (blur)="paymentSelectionControl?.markAsTouched()"
            id="PAY_CARD"
            [class.is-invalid]="shouldShowPaymentError()" />
          <span class="checkmark"></span>
        </label>
      </div>

      <div class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2"
        style="border: none;">
        <label for="PAY_CASH" class="d-flex w-100 container pl-0 font-size-primary">
          <span>{{"public.payment.payWithCash" | translate}}</span>
          <input
            type="radio"
            formControlName="selectedOptionalPayment"
            value="PAY_LATER_CASH"
            (click)="togglePaymentPayLaterOption('PAY_LATER_CASH')"
            (blur)="paymentSelectionControl?.markAsTouched()"
            id="PAY_CASH"
            [class.is-invalid]="shouldShowPaymentError()" />
          <span class="checkmark"></span>
        </label>
      </div>
    </form>

    <!-- Form Builder based error message -->
    <div class="text-danger font-size-secondary pb-2 pl-4"
         style="display: block;"
         *ngIf="shouldShowPaymentError()">
      <span>{{'public.global.errorMustSelectOne' | translate}}</span>
    </div>

  </div>

  <!-- Options for Admin -->
  <div *ngIf="showPaymentMethodsAdmin()">
    <div class="row mx-2">
      <div class="col-6 col-sm-3  align-items-center d-flex">
        {{ "public.payment.adminPayNow" | translate }}
      </div>
      <div class="col-6 col-sm-9">
        <div class="row">
          <div
            class="radio-custom radio-admin-capture option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center col-12 col-sm-4 col-md-3"
            style="border: none;">
            <label for="PAY_NOW_CASH" class="d-flex w-100 container pl-0 font-size-primary">
              <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment"
                value="PAY_NOW_CASH" (click)="togglePaymentPayLaterOption('PAY_NOW_CASH')" id="PAY_NOW_CASH" />
              <span class="checkmark"></span>
              <span>{{ "public.payment.adminPayCash" | translate }}</span>
            </label>
          </div>
          <div
            class="radio-custom radio-admin-capture option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center col-12 col-sm-4 col-md-3"
            style="border: none;">
            <label for="PAY_NOW_CARD" class="d-flex w-100 container pl-0 font-size-primary">
              <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment"
                value="PAY_NOW_CARD" (click)="togglePaymentPayLaterOption('PAY_NOW_CARD')" id="PAY_NOW_CARD" />
              <span class="checkmark"></span>
              <span>{{ "public.payment.adminPayCard" | translate }}</span>
            </label>
          </div>
          <div *ngIf="showOnlinePaymentmethod()"
            class="radio-custom radio-admin-capture option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center col-12 col-sm-4">
            <label for="PAY_ONLINE" class="d-flex w-100 container pl-0 font-size-primary">
              <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment"
                value="PAY_ONLINE" (click)="togglePaymentPayLaterOption('PAY_ONLINE')" id="PAY_ONLINE" />
              <span class="checkmark"></span>
              <span>{{'public.payment.adminPayOnline' | translate}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="divider mx-4"> </div>
    <div class="row mx-2">
      <div class="col-6 col-sm-3 align-items-center d-flex">
        {{ "public.payment.adminPayLater" | translate }}
      </div>
      <div class="col-6 col-sm-9">
        <div class="row">
          <div
            class="radio-custom radio-admin-capture option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center col-12 col-sm-4 col-md-3"
            style="border: none;">
            <label for="PAY_LATER_CASH" class="d-flex w-100 container pl-0 font-size-primary">
              <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment"
                value="PAY_LATER_CASH" (click)="togglePaymentPayLaterOption('PAY_LATER_CASH')" id="PAY_LATER_CASH" />
              <span class="checkmark"></span>
              <span>{{ "public.payment.adminPayCash" | translate }}</span>
            </label>
          </div>
          <div
            class="radio-custom radio-admin-capture option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center col-12 col-sm-4 col-md-3"
            style="border: none;">
            <label for="PAY_LATER_CARD" class="d-flex w-100 container pl-0 font-size-primary">
              <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment"
                value="PAY_LATER_CARD" (click)="togglePaymentPayLaterOption('PAY_LATER_CARD')" id="PAY_LATER_CARD" />
              <span class="checkmark"></span>
              <span>{{ "public.payment.adminPayCard" | translate }}</span>
            </label>
          </div>
          <div
            class="radio-custom radio-admin-capture option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center col-12 col-sm-4">
            <label for="PAY_LATER" class="d-flex w-100 container pl-0 font-size-primary">
              <input type="radio" [(ngModel)]="selectedOptionalPayment" name="selectedOptionalPayment" value="PAY_LATER"
                (click)="togglePaymentPayLaterOption('PAY_LATER')" id="PAY_LATER" />
              <span class="checkmark"></span>
              <span>{{'public.payment.adminPayUnknown' | translate}}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <!--x-->

  </div>


  <div *ngIf="storeSettings?.PAYMENT_ABA_PAYWAY_CREDIT_CARD_ENABLED">
    <div class="option-wrapper">
      <div
        class="variant-wrapper checkbox label-as-h3 d-flex justify-content-between align-items-center p-3 pl-4 theme-light">
        <label for="selectedOptionalPaymentMethod" class="d-flex flex-column w-100 container mb-0 font-size-heading">
          <div class="d-flex section-title theme-light">
            {{'public.payment.paymentMethodSelection' | translate}}
          </div>
        </label>
      </div>
    </div>

    <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('ABAPAY')"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
      <label class="d-flex flex-column w-100 container mb-0" for="abapay">
        <div class="row">
          <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.abapay' | translate}}</div>
          <div class="col pl-1">
            <img src="assets/img/payment_logos/abapay-abapay.png" width="100%" style="max-width: 60px">
          </div>
        </div>
        <input type="radio" id="abapay" [(ngModel)]="selectedOptionalPaymentMethod" name="selectedOptionalPaymentMethod"
          value="ABAPAY" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('CREDIT_CARD_VISA_MASTERCARD_JCB')"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
      <label class="d-flex flex-column w-100 container mb-0" for="creditcard">
        <div class="row">
          <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.creditcard' | translate}}
          </div>
          <div class="col pl-1">
            <img src="assets/img/payment_logos/abapay-creditcard.png" width="100%" style="max-width: 110px">
          </div>
        </div>
        <input type="radio" id="creditcard" [(ngModel)]="selectedOptionalPaymentMethod"
          name="selectedOptionalPaymentMethod" value="CREDIT_CARD_VISA_MASTERCARD_JCB" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('KHQR')"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2">
      <label class="d-flex flex-column w-100 container mb-0" for="khqr">
        <div class="row">
          <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.khqr' | translate}}</div>
          <div class="col pl-1">
            <img src="assets/img/payment_logos/abapay-khqr.png" width="100%" style="max-width: 75px">
          </div>
        </div>
        <input type="radio" id="khqr" [(ngModel)]="selectedOptionalPaymentMethod" name="selectedOptionalPaymentMethod"
          value="KHQR" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('WECHAT')"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2x">
      <label class="d-flex flex-column w-100 container mb-0" for="wechat">
        <div class="row">
          <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.wechat' | translate}}</div>
          <div class="col pl-1">
            <img src="assets/img/payment_logos/abapay-wechat.png" width="100%" style="max-width: 75px">
          </div>
        </div>
        <input type="radio" id="wechat" [(ngModel)]="selectedOptionalPaymentMethod" name="selectedOptionalPaymentMethod"
          value="WECHAT" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div *ngIf="storeSettings?.ABA_PAYWAY_PAYMENT_METHODS?.split('|')?.includes('ALIPAY')"
      class="radio-custom option-wrapper variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2x">
      <label class="d-flex flex-column w-100 container mb-0" for="alipay">
        <div class="row">
          <div class="col-md-0 p-0 d-flex align-items-center"> {{'admin.store.payment.method.alipay' | translate}}</div>
          <div class="col pl-1">
            <img src="assets/img/payment_logos/abapay-alipay.png" width="100%" style="max-width: 75px">
          </div>
        </div>
        <input type="radio" id="alipay" [(ngModel)]="selectedOptionalPaymentMethod" name="selectedOptionalPaymentMethod"
          value="ALIPAY" />
        <span class="checkmark"></span>
      </label>
    </div>
  </div>

  <!-- EOF: PAYMENT OPTIONS -->
  <!-- PAYMENT METHOD -->
  <div class="option-wrapper payment-method-wrapper"
    [ngClass]="{'pt-0': checkoutService.ifEnabledPaymentMandatory() && (checkoutService.countEnabledPaymentMethods() > 1)}"
    *ngIf="(selectedPaymentOption === PAYMENT_OPTION.PAY_NOW || checkoutService.ifEnabledPaymentMandatory()) && (selectedStore.settings.PAYMENT_OPTION !== 'optional' || selectedOptionalPayment === 'PAY_ONLINE')">
    <div class="variant-wrapper my-0">
      <h3 class="px-4 mt-3 mt-md-0 mb-0 font-size-heading" *ngIf="ifEnabledPaymentPaypal()">
        {{'public.payment.chooseYourPaymentMethod' | translate}}
      </h3>
      <!-- PAY WITH JCC -->
      <!-- Dont remove this we may need for future reference - Commenting to refecor Payment UI -->
      <!-- <div class="variant-wrapper radio d-flex justify-content-between align-items-center mx-3 mt-0 mb-2"
        [ngClass]="{'hide-input': (ifEnabledPaymentMethod(PAYMENT_METHOD.JCC) && !ifEnabledMultiplePaymentMethods())}"
        *ngIf="ifEnabledPaymentMethod(PAYMENT_METHOD.JCC)">
        <label for="var-rms" class="d-flex flex-column w-100 container pl-0 no-cursor font-size-primary">
          <div class="d-flex flex-row align-itmes-center">
            <span>{{'public.payment.creditCard' | translate}}</span>
            <img src="/assets/img/payment_logos/american_express.svg" class="pl-2" style="max-height: 22px;" />
            <img src="/assets/img/payment_logos/mastercard.svg" class="pl-2" style="max-height: 22px;" />
            <img src="/assets/img/payment_logos/uatp.svg" class="pl-2" style="max-height: 36px;" />
            <img src="/assets/img/payment_logos/visa.svg" style="max-height: 36px;" />
          </div>
          <input type="radio" name="payment-method" id="var-jcc" *ngIf="ifEnabledMultiplePaymentMethods()"
            (click)="setPaymentMethod(PAYMENT_METHOD.JCC)" />
          <span class="checkmark"></span>
        </label>
      </div> -->
      <form [formGroup]="jccCardForm" #jccForm class="checkout mx-2" action="{{jccServerLink}}"
        [ngClass]="{'d-none': selectedPaymentMethod != PAYMENT_METHOD.JCC}"
        *ngIf="ifEnabledPaymentMethod(PAYMENT_METHOD.JCC)" method="POST">
        <div class="variant-wrapper d-flex flex-column justify-content-start align-items-start mx-3 my-2"
          style="max-width: 100%;">
          <input type="hidden" name="Version" value="{{jccFormRequest?.version}}">
          <input type="hidden" name="MerID" value="{{jccFormRequest?.merchantId}}">
          <input type="hidden" name="AcqID" value="{{jccFormRequest?.acquirerId}}">
          <input type="hidden" name="MerRespURL" value="{{jccFormRequest?.responseUrl}}">
          <input type="hidden" name="MerCallbackURL" value="{{jccFormRequest?.callbackUrl}}">
          <input type="hidden" name="PurchaseAmt" value="{{jccFormRequest?.formattedPurchaseAmount}}">
          <input type="hidden" name="PurchaseCurrency" value="{{jccFormRequest?.currency}}">
          <input type="hidden" name="PurchaseCurrencyExponent" value="{{jccFormRequest?.currencyExponent}}">
          <input type="hidden" name="OrderID" value="{{jccFormRequest?.orderId}}">
          <input type="hidden" name="CaptureFlag" value="{{jccFormRequest?.captureFlag}}">
          <input type="hidden" name="Signature" value="{{jccFormRequest?.signature}}">
          <input type="hidden" name="SignatureMethod" value="{{jccFormRequest?.signatureMethod}}">
        </div>
      </form>

      <!-- PAY WITH PAYPAL -->
      <div class="variant-wrapper radio d-flex justify-content-between align-items-center mx-3 my-2 mt-3"
        [ngClass]="{'hide-input pl-0': (ifEnabledPaymentMethod(PAYMENT_METHOD.PAYPAL) && !ifEnabledMultiplePaymentMethods())}"
        *ngIf="ifEnabledPaymentMethod(PAYMENT_METHOD.PAYPAL)">
        <label for="var-paypal" class="d-flex flex-column w-100 container pl-0 font-size-primary"
          (click)="setPaymentMethod(PAYMENT_METHOD.PAYPAL)">{{'public.payment.paypal' | translate}}
          <img src="/assets/img/payment-paypal.png" class="paypal-img pt-1" />
          <input type="radio" name="payment-method" id="var-paypal" *ngIf="ifEnabledMultiplePaymentMethods()" />
          <span class="checkmark"></span>
        </label>
      </div>

      <!-- PAY WITH TRUSTPAYMENTS -->
      <app-trustpayment #trustpaymentComponent></app-trustpayment>
    </div>
  </div>
  <!-- <div class="section-separator pb-3"></div> -->
  <div *ngIf="selectedPaymentOption === PAYMENT_OPTION.PAY_NOW || checkoutService.ifEnabledPaymentMandatory()">
  </div>

  <div *ngIf="isPaymentMethodEnabled(storeSettings, paymentMethodEnabled.PAYMENT_GLOBAL_PAY_CREDIT_CARD_ENABLED)">
    <app-globalpay></app-globalpay>
  </div>

  <div *ngIf="isPaymentMethodEnabled(storeSettings, paymentMethodEnabled.PAYMENT_RMS_CREDIT_CARD_ENABLED)">
    <app-rms></app-rms>
  </div>

  <div *ngIf="isPaymentMethodEnabled(storeSettings, paymentMethodEnabled.PAYMENT_APCOPAY_CREDIT_CARD_ENABLED)">
    <app-apcopay #apcopayComponent></app-apcopay>
  </div>
  <!-- EOF: PAYMENT METHOD -->
</div>
